/**
 * LBX - Add to Cart
 *
 * This script is responsible for adding products to the cart.
 *
 */

import { connect } from 'react-redux';
import getStore from 'Util/Store';

const CartDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/Cart/Cart.dispatcher'
    );

const mapDispatchToProps = (dispatch) => ({
    addProductToCart: (options) => CartDispatcher.then(
        ({ default: dispatcher }) => dispatcher.addProductToCart(dispatch, options)
    )
});

const _addToCart = (sku, quantity) => {
    const store = getStore();
    const state = store.getState();
    const { lbx_add_to_cart_enabled } = state.ConfigReducer;

    console.log(state.ConfigReducer);

    try {
        if (String(lbx_add_to_cart_enabled) !== '1') {
            throw new Error('Function is disabled');
        }

        if (!(typeof sku === 'string' || typeof sku === 'number')) {
            throw new Error('SKU must be a string or number');
        }

        quantity = parseInt(quantity, 10);

        if (isNaN(quantity) || quantity <= 0) {
            throw new Error('Invalid quantity');
        }

        const { addProductToCart } = mapDispatchToProps(store.dispatch);

        return addProductToCart({ products: [{ sku, quantity }] });
    } catch (error) {
        console.error(`%c${error}`, 'color: white; background-color: red; border-radius: 1rem; padding: 0.15rem;');

        return Promise.reject(new Error(error));
    }
}

window.AddToCart = (sku, quantity) => _addToCart(sku, quantity);

connect(null, mapDispatchToProps)(_addToCart);
